import template from "./proxy-response-download.html";
function Controller($window) {
	const ctrl = this;

	function b64toBlob(b64Data, contentType) {
		const sliceSize = 512;
		const byteCharacters = atob(b64Data || "");
		const byteArrays = [];

		for(let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for(let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
	}

	function triggerDownload(blob, filename) {
		if($window.navigator && $window.navigator.msSaveOrOpenBlob) {
			$window.navigator.msSaveBlob(blob, filename);
			return;
		}

		const a = $window.document.createElement("a");
		a.href = $window.URL.createObjectURL(blob);
		a.download = filename || "download";
		$window.document.body.appendChild(a);
		a.click();
		$window.document.body.removeChild(a);
	}

	ctrl.$onInit = () => {
		const blob = b64toBlob(ctrl.content, ctrl.mediaType);
		ctrl.objectUrl = $window.URL.createObjectURL(blob);
		triggerDownload(blob, ctrl.filename);
	};

	ctrl.$onDestroy = () => {
		if(ctrl.objectUrl) {
			$window.URL.revokeObjectURL(ctrl.objectUrl);
			ctrl.objectUrl = null;
		}
	};
}
Controller.$inject = ["$window"];

export default angular.module("vesl.components.proxy-response-download", []).component("proxyResponseDownload", {
	bindings: {
		content: "<",
		mediaType: "<",
		filename: "<"
	},
	controller: Controller,
	template
}).name;
